import React from 'react';
import Card from '../../../../components/Card/Card';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { STATIC_PATH } from '../../../../config';
import { formatToCurrency, currencyToSign } from '../../../../utils/utils';
import { startSetDashboardSummary } from '../../../../actions/dashboard';

class FinancesWidget extends React.Component {
    componentDidMount() {
        this.props.startSetDashboardSummary()
    }

    render() {
        const { sum, currencies } = this.props;
        return (
            <Card className='simple-widget-3'>
                <Card.Body className='simple-widget-info'>
                    <FormattedMessage id='widgets.dashboard.summary.amount' />
                    <div className='finance-info'>
                        {sum.map((s, key) => (
                            <span key={key}>
                                <span>
                                    <b>{formatToCurrency(s)}</b>
                                </span>
                                <span>{currencyToSign(currencies[key])}</span>
                            </span>
                        ))}
                    </div>
                    <img src={`${STATIC_PATH}/img/finances-widget-icon.svg`} alt="Финансы" />
                </Card.Body>
            </Card>
        )
    }
}

const mapStateToProps = ({ dashboard, app }) => ({
    sum: dashboard.sum,
    currencies: app.globalSettings.currencies,
});
const mapDispatchToProps = dispatch => ({
    startSetDashboardSummary: () => dispatch(startSetDashboardSummary()),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(FinancesWidget));

